import { useContext, createElement, useCallback } from 'react';
import { ToggleIcon } from './toggle-icon';
import { ProTableSettingContext } from '../contexts/pro-table-setting-context';
export const ProTableCrossLineButton = () => {
    const { tableSetting, setTableSetting } = useContext(ProTableSettingContext);
    const handleClick = useCallback(() => setTableSetting((oldState) => ({
        ...oldState,
        crossline: !oldState.crossline,
    })), [setTableSetting]);
    return (createElement(ToggleIcon, { title: tableSetting.crossline ? '隐藏十字轴' : '十字轴', type: tableSetting.crossline ? 'eye-close' : 'eye', active: tableSetting.crossline, onClick: handleClick }));
};
ProTableCrossLineButton.displayName = 'ProTableCrossLineButton';
